<div>
    <div class="flex flex-row mb-8 mt-2">
        <mat-icon svgIcon="analytics" class="title-icon"></mat-icon>
        <span class="title ml-6">{{'TENANT_DETAILS.METRICS' | transloco }}</span>
    </div>
    <mat-divider class="neutral-blue-6"></mat-divider>
    <div class="p-24 eaas-metrics mt-24">
        <div class="flex flex-row justify-between">
            <div class="fw-600 fs-24 mb-20">{{'TENANT_DETAILS.ENVIRONMENT_USAGE' | transloco }}</div>
            <app-month-year-picker (monthChange)="applyMonthFilter($event)" [minDate]="instance?.dateCreated"></app-month-year-picker>
        </div>
        <div class="flex flex row">
            <div class="flex flex-col metrics-piechart mb-20 mt-16 p-24">
            <span class="fs-20 fw-500">{{'INSTANCE_DETAILS.RELEASE_PACKAGE' | transloco }}</span>
            @if (!metricsPieChartLoaded) {
                <div class="flex items-center justify-center metrics-spinner">
                    <mat-spinner diameter="20" color="primary" mode="indeterminate"></mat-spinner>
                </div>
            }
            @else if (metricsPieChartLoaded && configurationMonth?.length === 0) {
                <div class="no-data flex items-center justify-center pt-8 pb-8 fw-500 fs-16 mt-8 metrics-spinner mb-0 mat-subtitle-1">
                    <mat-icon svgIcon="error" class="icon-md-1 metrics-unavailable"></mat-icon>
                    <span class="metrics-unavailable ml-4">{{'INSTANCE_DETAILS.USAGE_NOT_AVAILABLE' | transloco }}</span>
                </div>
            }
            @else if (metricsPieChartLoaded && configurationMonth?.length > 0) {
                <div class="flex items-center">
                    <div echarts [options]="metricsPiechart" class="metrics-chart p-10"></div>
                    <div class="flex-col pl-30">
                        <div class="chart-label fs-14 fw-500 pb-16">{{'INSTANCE_DETAILS.DEPLOYED' | transloco }}</div>
                        <span class="fs-36 fw-500">{{successConfigStates?.length}}<span class="ml-8 mr-8">{{'INSTANCE_DETAILS.OF' | transloco }}</span>{{configurationMonth?.length}}</span>
                    </div>
                </div>
            } 
            </div>
            <div class="flex flex-col total-time-taken mb-20 ml-24 mt-16 p-24">
              <app-time-taken-pie  [runHours]="runHours" [shutDownHours]="shutDownHours" [timetakenChartLoaded]="timetakenChartLoaded" [isResponseOk]="isResponseOk" [isErrorResponse]="isErrorResponse"> </app-time-taken-pie>
            </div>
        </div>
        <div class="flex items-center mb-12">
            <div class="fw-600 fs-24 mat-subtitle-1 mb-0">
              {{'TENANT_DETAILS.ACTIVITY_LOG' | transloco }}
              @if (metricsLog?.length > 0) {
                <span class="ml-8">({{searchedMetricResult && metricsSearchTerm?.length > 0 ? searchedMetricResult.length : metricLogData?.length}})</span>
              } 
            </div>
            @if ( metricsLog && metricsLog.length > 0) {
                <div class="ml-16 metrics-search mt--20">
                    @if (metricsLog?.length !== 0) { <app-search-filter class="mt-20 ml-20" placeholder="SEARCH.SEARCH" (changed)="searchMetrcis($event)"></app-search-filter> }
                </div>
                <div class="ml-16" >
                    <button class="flex justify-center items-center filter pl-6 pr-16 h-36" (click)="filterMetricLogs()">
                        <mat-icon class="mr-4" svgIcon="filter_alt"></mat-icon>
                        <span class="mat-body-1 fw-500">{{'SOLUTIONS.FILTERS' | transloco }}</span>
                    </button>
                </div>
            }
        </div>
        <div class="flex flex-row items-center">
            @if (selectedMetricAction?.length > 0) {
                <div class="mt-20 mr-4 pt-8 pb-8 filtered-items flex items-center fs-16 fw-500">
                    @for (action of selectedMetricAction; track action) {
                        <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
                            {{getAction(action)}}<mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelMetricAction(action)"></mat-icon>
                        </span>
                    }
                </div>
            }
            @if (metricLogData && metricStartDate && metricEndDate) {
                <div class="mt-20 mr-4 pt-8 pb-8 filtered-items flex items-center fs-16 fw-500">
                    <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
                        {{'SCHEDULES.DATE' | transloco}} : {{ datePipe.transform(metricStartDate, 'dd MMM yyyy')+ '- ' + datePipe.transform(metricEndDate, 'dd MMM yyyy') }}
                        <mat-icon svgIcon="close" class="ml-8 icon-sm" (click)="cancelMetricDate()"></mat-icon>
                    </span>
                </div>
            }
            <div class="flex flex-row items-center mt-20">
                @if (selectedMetricAction?.length > 0 || (metricStartDate && metricEndDate)) { 
                  <span class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg"(click)="resetMetricFilter()">{{ 'BUTTONS.CLEAR_ALL' | transloco }}</span>
                }
            </div>
        </div>
        @if ((metricsLog && metricsLog.length > 0) || showActivityLoader) {
            <div> <app-table [initialDataSource]="metricLogData" [searchTerm]="metricsSearchTerm" [displayColumns]="metricsDisplayColumns" [dataLoading]="showActivityLoader" [showSkeletonLoader]="true" [dataSourceLength]="true" pageName="metricsLog" (searchedResults)="searchedMetricItems($event)"></app-table></div>
        } @else {
            <div class="external-package p-24">
                @if (isLogFailed || metricsLog?.length === 0) {
                    <div class="no-data flex items-center justify-center pt-8 pb-8 fw-600 fs-20 m-60">
                        <img src="/assets/images/instance-not-found-small.png">
                        <div class="ml-10">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
                    </div>
                } 
            </div>
        }
    </div>
</div>